<div *ngIf="workflowHistory" class="workflow-history-container">
  <div *ngFor="let item of workflowHistory" fxLayout="column" fxLayoutAlign="center stretch">

    <div *ngIf="item.trigger || item.comments" fxLayout="column" fxLayoutAlign="center center">
      <mat-icon *ngIf="item.trigger" class="workflow-history-next-state-icon">straight</mat-icon>

      <mat-card class="contrast mat-card-inline-sm">
        <mat-card-content fxLayout="column" fxLayoutAlign="center center">
          
          <div *ngIf="item.trigger" class="text-info workflow-history-trigger-name" [matTooltip]="item.triggerDescription">
            {{ item.triggerName }}
          </div>

          <span class="text-small">
            {{ getTransitionTypeText(item) }} by
            <span class="text-success">
              {{ item.stateChangedBy }}
            </span>
            about
            <span class="text-purple" [matTooltip]="item.stateChangedDate">
              {{ timeAgoString(item.stateChangedDate) }}
            </span>
          </span>
          
          <mat-card *ngIf="item.comments" class="mat-card-inline-sm">
            <mat-card-content fxLayout="column">
              <div style="white-space: pre-line">
                {{ item.comments }}
              </div>
            </mat-card-content>
          </mat-card>
            
        </mat-card-content>
      </mat-card>

    </div>

    <div *ngIf="stateHasChanged(item)" fxLayout="column" fxLayoutAlign="center center">
      <mat-icon class="workflow-history-next-state-icon">straight</mat-icon>

      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px" [matTooltip]="item.stateDescription">
        <product-workflow-icon
          [workflowStateType]="item.stateType">
        </product-workflow-icon>

        <span class="workflow-history-state-name">
          {{ item.stateName }}
        </span>
      </div>
    </div>
    
  </div>
</div>